import { createDataHandler } from "./handler/metadata.js";
import { defaultKeybinds } from "./dom/keybinds.js";
import { registerKeyboardListener } from "./dom/listener.js";
//#region src/dom.ts
/**
* Metadata handler (query key `element`) that ties a node to a focusable DOM element
*
* Exposes `.query(tree, id)` to resolve the element for focus sync.
*/
const elementHandler = createDataHandler("element");
//#endregion
export { defaultKeybinds, elementHandler, registerKeyboardListener };

//# sourceMappingURL=dom.js.map